<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form ref="form" label-width="120px" :model="dataForm">
        <el-form-item label="审批流程类型：">
          <p>{{ dataForm.ProcName }}</p>
        </el-form-item>
        <el-form-item label="流程编码：">
          <p>{{ dataForm.ProcCode }}</p>
        </el-form-item>
        <el-form-item label="审批流程：">
          <el-timeline style="margin-top:20px">
            <el-timeline-item>发起</el-timeline-item>
            <el-timeline-item
              v-for="(step, index) in dataForm.Steps"
              :key="index"
            >
              <el-row>
                <div style="float:left;width:40%">
                  <el-form-item label="审核步骤：">
                    <p>{{ step.StepName }}</p>
                  </el-form-item>
                </div>
                <div style="float:left;width:40%">
                  <el-form-item label="审批者：">
                    <p>{{ step.PartName }}</p>
                  </el-form-item>
                </div>
              </el-row>
            </el-timeline-item>
            <el-timeline-item>结束</el-timeline-item>
          </el-timeline>
        </el-form-item>
      </el-form>
      <employee-picker
        v-if="formVisible"
        @pickerCallBack="employeeCallBack"
      ></employee-picker>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isConfirm: false,

      isAudit: 1, //是否审核
      formVisible: false,

      index: "",
      width: "60%"
    };
  },
  mounted() {
    this.loadStepData();
  },
  components: {
    OfDialog
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //加载审批步骤
    loadStepData() {
      if (this.dataForm.Id) {
        this.isloading = true;
        let params={Id:this.dataForm.Id}
        api.QueryApprovalStep(params).then(rep => {
          if (rep.data.Code === 0) {
            this.isAudit = rep.data.Data.length === 0 ? 0 : 1;
            this.dataForm.Steps = rep.data.Data;
          }
          this.isloading = false;
        });
      }
    }
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}

.el-input >>> .el-input__prefix {
  margin-left: 75%;
  margin-top: 2%;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
</style>

<style>
.hide .el-button--primary {
  display: none;
}
</style>
